import { render } from "./TranslationResult.vue?vue&type=template&id=6e2b68ba&scoped=true"
import script from "./TranslationResult.vue?vue&type=script&lang=js"
export * from "./TranslationResult.vue?vue&type=script&lang=js"

import "./TranslationResult.vue?vue&type=style&index=0&id=6e2b68ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2b68ba"]])

export default __exports__